import React from "react";
import Sea from "../../Admin/Question/View/Background/Sea/Sea";
import List from "./TrackList";

class Lessons extends React.Component {
    render() {
        return <List {...this.props} typeOfList="Lessons" defaultIndexValue={5} Background={<Sea />} Link="/Tracks/Lessons/" typeOfLesson="Lessons" Icon="fal fa-layer-group" />;
    }
}
export default Lessons;